// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_inputWrapper__faV4N {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  align-items: flex-start;
}
.Input_inputWrapper__faV4N p {
  font-size: var(--font-normal);
  font-weight: bold;
  color: var(--color-secundario);
  margin-bottom: 0.5rem !important;
}

.Input_inputCustom__2\\+LfQ {
  width: 100%;
  padding: 10px 36px 10px 12px;
  border: 1px solid var(--color-gris);
  background-color: var(--color-blanco);
  border-radius: 8px;
  font-size: 12px;
}
.Input_inputCustom__2\\+LfQ:focus-visible {
  outline: none;
  border: 1px solid var(--color-primario-dark);
}
.Input_inputCustom__2\\+LfQ:focus {
  outline: none;
}
.Input_inputCustom__2\\+LfQ:read-only, .Input_inputCustom__2\\+LfQ:disabled {
  background-color: #eee;
}
.Input_inputCustom__2\\+LfQ::placeholder {
  color: var(--color-gris);
}

.Input_inputIcon__vvc8o {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: var(--color-gris);
  cursor: pointer;
}

.Input_inputContainer__1OSHO {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.Input_inputError__fkFU6 {
  border: 1px solid #dc3545 !important;
}

.Input_errorText__3REE6 {
  margin: 6px 0 0;
  font-size: var(--font-chica) !important;
  color: #dc3545;
}

.Input_helperText__BmYWN {
  margin: 6px 0 0;
  font-size: var(--font-chica) !important;
  color: #6c757d;
}

.Input_label__U9NhE {
  font-size: var(--font-chica);
  margin-bottom: 0.4rem;
}

.Input_inputGroup__\\+-FLJ {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.Input_inputPrefix__jv6in,
.Input_inputSuffix__fxs7W {
  position: absolute;
  top: 1px;
  bottom: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 0 0.75rem;
  font-size: var(--font-chica);
  font-weight: 700;
  color: #979fa8;
  background-color: var(--color-gris-claro);
  pointer-events: none;
}

.Input_inputPrefix__jv6in {
  left: 1px;
  border-radius: var(--radius-10) 0 0 var(--radius-10);
  border-right: 1px solid var(--color-gris);
}

.Input_inputSuffix__fxs7W {
  right: 1px;
  border-radius: 0 var(--radius-10) var(--radius-10) 0;
  border-left: 1px solid var(--color-gris);
}

.Input_withPrefix__x5dZU {
  padding-left: 48px;
}

.Input_withSuffix__JuuQ2 {
  padding-right: 48px;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AACF;AACE;EACE,6BAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;AACJ;;AAGA;EACE,WAAA;EACA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AAAF;AAEE;EACE,aAAA;EACA,4CAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EAEE,sBAAA;AAHJ;AAME;EACE,wBAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AALF;;AAQA;EACE,oCAAA;AALF;;AAQA;EACE,eAAA;EACA,uCAAA;EACA,cAAA;AALF;;AAQA;EACE,eAAA;EACA,uCAAA;EACA,cAAA;AALF;;AAQA;EACE,4BAAA;EACA,qBAAA;AALF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AANF;;AASA;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;EACA,oBAAA;AANF;;AASA;EACE,SAAA;EACA,oDAAA;EACA,yCAAA;AANF;;AASA;EACE,UAAA;EACA,oDAAA;EACA,wCAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,mBAAA;AANF","sourcesContent":[".inputWrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  align-items: flex-start;\r\n\r\n  p {\r\n    font-size: var(--font-normal);\r\n    font-weight: bold;\r\n    color: var(--color-secundario);\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n}\r\n\r\n.inputCustom {\r\n  width: 100%;\r\n  padding: 10px 36px 10px 12px;\r\n  border: 1px solid var(--color-gris);\r\n  background-color: var(--color-blanco);\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n\r\n  &:focus-visible {\r\n    outline: none;\r\n    border: 1px solid var(--color-primario-dark);\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n\r\n  &:read-only,\r\n  &:disabled {\r\n    background-color: #eee;\r\n  }\r\n\r\n  &::placeholder {\r\n    color: var(--color-gris);\r\n  }\r\n}\r\n\r\n.inputIcon {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 18px;\r\n  color: var(--color-gris);\r\n  cursor: pointer;\r\n}\r\n\r\n.inputContainer {\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.inputError {\r\n  border: 1px solid #dc3545 !important;\r\n}\r\n\r\n.errorText {\r\n  margin: 6px 0 0;\r\n  font-size: var(--font-chica) !important;\r\n  color: #dc3545;\r\n}\r\n\r\n.helperText {\r\n  margin: 6px 0 0;\r\n  font-size: var(--font-chica) !important;\r\n  color: #6c757d;\r\n}\r\n\r\n.label {\r\n  font-size: var(--font-chica);\r\n  margin-bottom: .4rem;\r\n}\r\n\r\n\r\n.inputGroup {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.inputPrefix,\r\n.inputSuffix {\r\n  position: absolute;\r\n  top: 1px;\r\n  bottom: 1px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 36px;\r\n  padding: 0 0.75rem;\r\n  font-size: var(--font-chica);\r\n  font-weight: 700;\r\n  color: #979fa8;\r\n  background-color: var(--color-gris-claro);\r\n  pointer-events: none;\r\n}\r\n\r\n.inputPrefix {\r\n  left: 1px;\r\n  border-radius: var(--radius-10) 0 0 var(--radius-10);\r\n  border-right: 1px solid var(--color-gris);\r\n}\r\n\r\n.inputSuffix {\r\n  right: 1px;\r\n  border-radius: 0 var(--radius-10) var(--radius-10) 0;\r\n  border-left: 1px solid var(--color-gris);\r\n}\r\n\r\n.withPrefix {\r\n  padding-left: 48px;\r\n}\r\n\r\n.withSuffix {\r\n  padding-right: 48px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `Input_inputWrapper__faV4N`,
	"inputCustom": `Input_inputCustom__2+LfQ`,
	"inputIcon": `Input_inputIcon__vvc8o`,
	"inputContainer": `Input_inputContainer__1OSHO`,
	"inputError": `Input_inputError__fkFU6`,
	"errorText": `Input_errorText__3REE6`,
	"helperText": `Input_helperText__BmYWN`,
	"label": `Input_label__U9NhE`,
	"inputGroup": `Input_inputGroup__+-FLJ`,
	"inputPrefix": `Input_inputPrefix__jv6in`,
	"inputSuffix": `Input_inputSuffix__fxs7W`,
	"withPrefix": `Input_withPrefix__x5dZU`,
	"withSuffix": `Input_withSuffix__JuuQ2`
};
export default ___CSS_LOADER_EXPORT___;
